import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
} from '../core/ReactiveState.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ReactiveLoadings35224pps2d9 as ReactiveLoading } from './ReactiveContext.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Key_getInstance2js7sv2agqob1 as Key_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineDispatcher.mjs';
import {
  CoroutineStart_DEFAULT_getInstance2bbgmtawlnkke as CoroutineStart_DEFAULT_getInstance,
  CoroutineStart_UNDISPATCHED_getInstance1s89xhsoy2cne as CoroutineStart_UNDISPATCHED_getInstance,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  plusypd30qeai057 as plus,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { DependencyChangeListener1518w8dt8yuu7 as DependencyChangeListener } from './DependencyChangeListener.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../core/signals.mjs';
import { onRemove3k528udkni1ni as onRemove } from './CalculationContext.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../core/coreInterfaces.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launchWithStart, $completion) {
  // Inline function 'com.lightningkite.reactive.core.reactiveState' call
  var tmp;
  try {
    var tmp_0 = $this.saj_1.paj_1($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp$ret$0 = tmp_0;
    tmp = _ReactiveState___init__impl__fvdp9b(tmp$ret$0);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof CancellationException()) {
      var _unused_var__etf5q3 = $p;
      tmp_1 = Companion_getInstance().mah_1;
    } else {
      if ($p instanceof ReactiveLoading()) {
        var _unused_var__etf5q3_0 = $p;
        tmp_1 = Companion_getInstance().mah_1;
      } else {
        if ($p instanceof Exception()) {
          var e = $p;
          tmp_1 = Companion_getInstance().uah(e);
        } else {
          throw $p;
        }
      }
    }
    tmp = tmp_1;
  }
  var result = tmp;
  var tmp_2;
  if (!$this.saj_1.naj_1) {
    tmp_2 = true;
  } else {
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
    var tmp_3 = _ReactiveState___get_raw__impl__92ipya(result);
    tmp_2 = !(tmp_3 instanceof InternalReactiveNotReady());
  }
  if (tmp_2) {
    $this.saj_1.oaj_1.pah(result);
  }
  $this.saj_1.nai();
  $this.taj_1._v = true;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launchWithStart, $completion) {
  // Inline function 'com.lightningkite.reactive.core.reactiveState' call
  var tmp;
  try {
    var tmp_0 = $this.uaj_1.paj_1($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp$ret$0 = tmp_0;
    tmp = _ReactiveState___init__impl__fvdp9b(tmp$ret$0);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof CancellationException()) {
      var _unused_var__etf5q3 = $p;
      tmp_1 = Companion_getInstance().mah_1;
    } else {
      if ($p instanceof ReactiveLoading()) {
        var _unused_var__etf5q3_0 = $p;
        tmp_1 = Companion_getInstance().mah_1;
      } else {
        if ($p instanceof Exception()) {
          var e = $p;
          tmp_1 = Companion_getInstance().uah(e);
        } else {
          throw $p;
        }
      }
    }
    tmp = tmp_1;
  }
  var result = tmp;
  var tmp_2;
  if (!$this.uaj_1.naj_1) {
    tmp_2 = true;
  } else {
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
    var tmp_3 = _ReactiveState___get_raw__impl__92ipya(result);
    tmp_2 = !(tmp_3 instanceof InternalReactiveNotReady());
  }
  if (tmp_2) {
    $this.uaj_1.oaj_1.pah(result);
  }
  $this.vaj_1._v = true;
  return Unit_instance;
}
function launchWithStart($this, _this__u8e3s4, block) {
  var tmp;
  var tmp0_safe_receiver = _this__u8e3s4.ea2().cd(Key_getInstance());
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qa8(_this__u8e3s4.ea2())) === false) {
    tmp = CoroutineStart_UNDISPATCHED_getInstance();
  } else {
    tmp = CoroutineStart_DEFAULT_getInstance();
  }
  return launch(_this__u8e3s4, VOID, tmp, block);
}
var ReactiveContextSuspending$startCalculation$slambdaClass;
function ReactiveContextSuspending$startCalculation$slambda() {
  if (ReactiveContextSuspending$startCalculation$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $done) {
        this.saj_1 = this$0;
        this.taj_1 = $done;
      }
      wah($this$launchWithStart, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launchWithStart), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ReactiveContextSuspending$startCalculation$slambdaClass = $;
  }
  return ReactiveContextSuspending$startCalculation$slambdaClass;
}
function ReactiveContextSuspending$startCalculation$slambda_0(this$0, $done) {
  var i = new (ReactiveContextSuspending$startCalculation$slambda())(this$0, $done);
  var l = ($this$launchWithStart, $completion) => i.wah($this$launchWithStart, $completion);
  l.$arity = 1;
  return l;
}
var ReactiveContextSuspending$runOnceWhileDead$slambdaClass;
function ReactiveContextSuspending$runOnceWhileDead$slambda() {
  if (ReactiveContextSuspending$runOnceWhileDead$slambdaClass === VOID) {
    class $ {
      constructor($$this$run, $done) {
        this.uaj_1 = $$this$run;
        this.vaj_1 = $done;
      }
      wah($this$launchWithStart, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launchWithStart), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ReactiveContextSuspending$runOnceWhileDead$slambdaClass = $;
  }
  return ReactiveContextSuspending$runOnceWhileDead$slambdaClass;
}
function ReactiveContextSuspending$runOnceWhileDead$slambda_0($$this$run, $done) {
  var i = new (ReactiveContextSuspending$runOnceWhileDead$slambda())($$this$run, $done);
  var l = ($this$launchWithStart, $completion) => i.wah($this$launchWithStart, $completion);
  l.$arity = 1;
  return l;
}
var ReactiveContextSuspendingClass;
function ReactiveContextSuspending() {
  if (ReactiveContextSuspendingClass === VOID) {
    class $ extends DependencyChangeListener() {
      constructor(scope, useLastWhileLoading, reportTo, action) {
        useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
        reportTo = reportTo === VOID ? RawReactive().yah() : reportTo;
        super();
        this.maj_1 = scope;
        this.naj_1 = useLastWhileLoading;
        this.oaj_1 = reportTo;
        this.paj_1 = action;
        this.qaj_1 = null;
        this.raj_1 = false;
        onRemove(this.maj_1, () => {
          this.lai();
          return Unit_instance;
        });
      }
      yai() {
        this.raj_1 = true;
        var tmp0_safe_receiver = this.qaj_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.ma3();
        }
        this.mai();
        var tmp = this;
        // Inline function 'kotlin.let' call
        var tmp0 = plus(this.maj_1, this);
        var tmp$ret$0;
        $l$block_0: {
          var done = {_v: false};
          var job = launchWithStart(this, tmp0, ReactiveContextSuspending$startCalculation$slambda_0(this, done));
          if (done._v) {
            tmp$ret$0 = null;
            break $l$block_0;
          } else {
            if (!this.naj_1) {
              this.oaj_1.pah(Companion_getInstance().mah_1);
            }
            tmp$ret$0 = job;
            break $l$block_0;
          }
        }
        tmp.qaj_1 = tmp$ret$0;
      }
      zai() {
        var tmp = this;
        // Inline function 'kotlin.run' call
        var done = {_v: false};
        var job = launchWithStart(this, this.maj_1, ReactiveContextSuspending$runOnceWhileDead$slambda_0(this, done));
        var tmp_0;
        if (done._v) {
          tmp_0 = null;
        } else {
          if (!this.naj_1) {
            this.oaj_1.pah(Companion_getInstance().mah_1);
          }
          tmp_0 = job;
        }
        tmp.qaj_1 = tmp_0;
      }
      fai() {
        this.yai();
      }
      gai() {
        if (!this.naj_1) {
          this.oaj_1.pah(Companion_getInstance().mah_1);
        }
      }
      lai() {
        super.lai();
        this.raj_1 = false;
        var tmp0_safe_receiver = this.qaj_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this.qaj_1 = null;
          tmp0_safe_receiver.ma3();
        }
      }
      qah() {
        return this.oaj_1.qah();
      }
      tah(listener) {
        return this.oaj_1.tah(listener);
      }
      iaj() {
        return this.oaj_1.iaj();
      }
    }
    initMetadataForClass($, 'ReactiveContextSuspending', VOID, VOID, [DependencyChangeListener(), Reactive()]);
    ReactiveContextSuspendingClass = $;
  }
  return ReactiveContextSuspendingClass;
}
//region block: exports
export {
  ReactiveContextSuspending as ReactiveContextSuspending39biijty1bpc5,
};
//endregion

//# sourceMappingURL=ReactiveContextSuspending.mjs.map
